import React, { useEffect } from "react";
import TissEditor from "../Editor/TissEditor";
import BreadCrump from "../tools/breadcrump";
import HeaderOfPage from "../tools/headerOfPage";
import { ReactComponent as Logo } from "./ir.svg";
import axios from "axios";
import { Config } from "ckeditor5";
import { config } from "../../data/config";

import { getCookies } from "cookies-next";
import ShowArticle from "../../pages/showarticle";
import ShowArticleContainer from "../tools/showArticle";

export default function IranMap() {
    const [id, setId] = React.useState(null);
    const [mousePos, setMousePos] = React.useState({ x: 0, y: 0 });

    let cookie = getCookies();

    const [key, setKey] = React.useState<any>(1);
    const [article, setAritlce] = React.useState<any>(null);
    const [data, setData] = React.useState<any>(null);
    const [currentMouse, setCurrentMouse] = React.useState<any>(null);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Feature',
            url: '/dashboard/Feature'
        },
        {
            name: 'نقشه ایران',
            url: null
        },
    ];

    const handleClick = (e: any) => {
        loadcontainer();
        const id = e.target.id;
        setId(id);
        // reset all paths to default color
        const paths = document.querySelectorAll("path");
        // paths.forEach((p) => p.setAttribute("fill", "#ddd"));
        const keys = key + 1;
        setKey(keys);
        // set selected color
        e.target.setAttribute("fill", "red");


    };
    const mouseHover = (e: React.MouseEvent<SVGElement>) => {
        const target = e.target as SVGElement;
        var currentid = target.getAttribute('id');
        setMousePos({ x: e.clientX, y: e.clientY+100 });

        if (currentid != currentMouse) {
            setCurrentMouse(currentid);

            const marticle = data.find((item: any) => item.parent === currentid);
            setAritlce(marticle != undefined ? [marticle] : null);
        }

    };
    const loadcontainer = async () => {
        const paths = document.querySelectorAll("path");
        paths.forEach((p) => p.setAttribute("fill", "#ddd"));

        await axios.get(config.url + '/v1/dashboard/container/component/map', {
            headers: {
                Authorization: 'Bearer ' + cookie['token'],
            }
        }).then(async (result) => {
            console.log(result.data.message);
            setData(result.data.message);
            paths.forEach((p) => {
                var x = result.data.message.find((items: any) => items.parent === p.getAttribute('id'));

                if (x != undefined) {
                    p.setAttribute("fill", "#3b82f6");
                } else {
                    setAritlce(null);
                }
                console.log(x);
            });

        });
    }

    useEffect(() => {
        loadcontainer();
    }, []);
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4    mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="نقشه ایران"></HeaderOfPage>

                <div className="grid grid-cols-2">

                    <div className="col-span-2 m-4">
                        <div className="text-center mb-4 ">متن بالای صفحه نقشه</div>
                        <TissEditor component='maptext' parent={`2001`}  ></TissEditor>
                        <hr ></hr>
                    </div>
                    <div className=" directions justify-center ">
                        <div className="flex justify-center" >
                            <button className={`bg-gray-500 text-white p-3 rounded`} onClick={(e) => { loadcontainer(); }}>دوباره خوانی</button>
                        </div>

                        <Logo onMouseMove={mouseHover} onClick={(e) => { handleClick(e) }} ></Logo>

                        {
                            article != undefined && article != null && <div
                                className="absolute mymap z-20 bg-white p-2 rounded shadow"
                                style={{ top: mousePos.y + 15, left: mousePos.x + 15 }}


                            ><ShowArticleContainer data={article} ></ShowArticleContainer></div>
                        }

                    </div>
                    <div key={key}>

                        {
                            id != null && id != "" && <TissEditor component='map' parent={id}  ></TissEditor>
                        }

                    </div>
                </div>


            </div>
        </>
    )
}